<template>
  <div class="betascore-tracker-pattern">
    <CalicoSubHeader
      title="Your BetaScores"
      :tooltip-header="tooltipHeader"
      :tooltip-body="tooltipBody"
      :tabs="tabs"
    />

    <CalicoTrackerTableHeader
      v-if="items.length > 0"
      :sort-ascending="sortAscending"
      :hide-expiration="isHistory"
      @toggle-sort="$emit('toggle-sort')"
    />

    <CalicoTrackerEmptyState
      v-if="items.length === 0"
      @find-business="$emit('find-business')"
    />

    <CalicoTrackerItem
      v-for="item in items"
      :key="item.businessId"
      :business="item"
      :hide-expiration="isHistory"
      @click="$emit('select', { item, isHistory })"
    />
  </div>
</template>

<script>
import CalicoSubHeader from '@/components/calico/subHeader/index.vue';
import CalicoTrackerTableHeader from '@/components/calico/trackerTableHeader/index.vue';
import CalicoTrackerItem from '@/components/calico/trackerItem/index.vue';
import CalicoTrackerEmptyState from '@/components/calico/trackerEmptyState/index.vue';
import { TrackerScope, TrackerTimeState, Tooltips } from '@/enums/index.js';

export default {
  name: 'CalicoBetascoreTracker',

  components: {
    CalicoSubHeader,
    CalicoTrackerTableHeader,
    CalicoTrackerItem,
    CalicoTrackerEmptyState
  },

  props: {
    items: { type: Array, default: () => [] },
    sortAscending: { type: Boolean, default: false },
    hasYouItems: { type: Boolean, default: false },
    hasOrganizationItems: { type: Boolean, default: false },
    hasHistoryItems: { type: Boolean, default: false }
  },

  emits: ['toggle-sort', 'select', 'find-business'],

  data() {
    return {
      tooltipHeader: Tooltips.TRACKER_HEADER,
      tooltipBody: Tooltips.TRACKER_BODY
    };
  },

  computed: {
    tabs() {
      return [
        {
          key: TrackerScope.YOU,
          label: 'You',
          icon: 'bi bi-person-fill',
          to: `#${TrackerScope.YOU}`,
          disabled: !this.hasYouItems,
        },
        {
          key: TrackerScope.ORGANIZATION,
          label: 'Organization',
          icon: 'bi bi-building',
          to: `#${TrackerScope.ORGANIZATION}`,
          disabled: !this.hasOrganizationItems,
        },
        {
          key: TrackerTimeState.HISTORY,
          label: 'History',
          icon: 'bi bi-clock-history',
          to: `#${TrackerTimeState.HISTORY}`,
          disabled: !this.hasHistoryItems
        }
      ];
    },

    isHistory() {
      return this.$route.hash === `#${TrackerTimeState.HISTORY}`
    },
    
  }
};
</script>

<style scoped lang="scss">
.betascore-tracker-pattern {
  @include stack-space($space-medium);
  @include inset-space($space-medium);
  gap: $space-none;
}
</style>
